import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

/**
 * BarcodeLabel — renders a NYLSU printable label using jsbarcode.
 * Size ~40x25mm at 96dpi = ~151x94px. Slightly larger for print clarity.
 */
export default function BarcodeLabel({
  brand = "NYLSU",
  styleName,
  color,
  size,
  sku,
  barcode,
  price,
  currency = "EUR",
  showPrice = true,
  format = "CODE128",
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !barcode) return;
    try {
      const fmt = format === "EAN13" && /^\d{13}$/.test(barcode) ? "EAN13" : "CODE128";
      JsBarcode(ref.current, barcode, {
        format: fmt,
        width: 1.6,
        height: 40,
        displayValue: true,
        fontSize: 11,
        margin: 2,
        font: "monospace",
        textMargin: 1,
        background: "#ffffff",
      });
    } catch (e) {
      // ignored — label just renders without the barcode graphic
    }
  }, [barcode, format]);

  const money = price != null
    ? new Intl.NumberFormat("en-GB", { style: "currency", currency, maximumFractionDigits: 0 }).format(price)
    : "";

  return (
    <div
      className="nylsu-label border bg-white text-black"
      style={{
        width: "220px",
        padding: "8px 10px",
        borderColor: "#0a0a0a",
        boxSizing: "border-box",
      }}
      data-testid="barcode-label"
    >
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 11, letterSpacing: "0.3em", fontWeight: 300 }}>
        {brand}
      </div>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 13, lineHeight: 1.15, marginTop: 2, minHeight: 30 }}>
        {styleName || ""}
      </div>
      <div style={{ fontSize: 9, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C5A54", marginTop: 2 }}>
        {[color, size].filter(Boolean).join(" · ")}
      </div>
      <svg ref={ref} style={{ display: "block", width: "100%", marginTop: 4 }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 9, marginTop: 2 }}>
        <span style={{ fontFamily: "monospace" }}>{sku}</span>
        {showPrice && money && (
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 12 }}>{money}</span>
        )}
      </div>
    </div>
  );
}
